// NOTICE: KAPTION-INTEGRATION
import ApiClient from './ApiClient';

class KaptionAiSuggestions extends ApiClient {
  constructor() {
    super('kaption_ai_suggestions', { accountScoped: true });
  }

  fetchSuggestions({ conversationId, inboxId, agentPrompt, language }) {
    return this.post('fetch', {
      conversation_id: conversationId,
      inbox_id: inboxId,
      agent_prompt: agentPrompt,
      language,
    });
  }
}

export default new KaptionAiSuggestions();
